export const normalizeVisualPromptError = (err: unknown): Error =>
  err instanceof Error ? err : new Error(String(err));
